import BaseStore from '../base-store'

let options = {}
export default new BaseStore('venues', options)



// WEBPACK FOOTER //
// ./src/store/modules/venues.store.js